export default "__VITE_ASSET__XeqQUzKf__"